import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { Warning } from '@phosphor-icons/react';

const ManualPaymentWarning = ({ message }) => {
  return (
    <Alert 
      severity="warning" 
      icon={<Warning size={20} />}
      sx={{ mb: 2 }}
    >
      <AlertTitle>Cannot Edit Payment Status</AlertTitle>
      {message || 'This invoice has been confirmed by Stripe. Payment status cannot be manually changed once Stripe has confirmed the payment.'}
    </Alert>
  );
};

export default ManualPaymentWarning;
